// extracted by mini-css-extract-plugin
export default {"root":"PageNotFound_root__BO5Z4","errorCode":"PageNotFound_errorCode__GVsTs","text":"PageNotFound_text__guYwo"};